// extracted by mini-css-extract-plugin
export default {"simpleQuestions":"RemarksField_simpleQuestions__+J8T7"};